(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('DrinkProducerReportController', DrinkProducerReportController);

	DrinkProducerReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function DrinkProducerReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			loading: true,
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Date',
							'Bottles Drank'
						];

						var keyName = 'Producer';
						var keyNamePlural = keyName + 's';

						// add only those that were drank
						lodash.forEach(wineEntities, function(wine) {
							var drinks = wine.getDrinkHistory();

							if (drinks && drinks.length > 0) {
								self.wines.push(wine);
							}
						});

						var totalWines = self.wines.length;

						// by producer
						var winesGrouped = lodash.groupBy(self.wines, function(w) {
							return (w.producer && w.producer.name) ? lodash.capitalize(w.producer.name.toLowerCase()) : 'Unknown';
						});

						// initialize totals
						var grandTotals = {
							qtyDrank: 0,
							groups: Object.keys(winesGrouped).length,
							wines:  totalWines
						};

						lodash.forEach(winesGrouped, function(wines, group) {
							var groupTotals = {
								qtyDrank: 0
							};

							var formattedWines = [];

							lodash.forEach(wines, function(wine) {
								var varietal = (wine.varietal && wine.varietal.name) ? wine.varietal.name + ' ' : '';
								var category = (wine.category && wine.category.name) ? wine.category.name : '';
								var type = varietal + category;

								var drinks = wine.getDrinkHistory();

								lodash.forEach(drinks, function(drink) {
									// totals value for grouping
									groupTotals.qtyDrank += drink.qty;

									// data we want to display on a single wine
									formattedWines.push({
										name: wine.getFullName(),
										appelation: wine.getFullAppellation(),
										type: type,
										size: wine.bottleSize.name,
										qtyInCellar: wine.cellar.qty,
										qtyDrank: $window.numeral(drink.qty).format('0,0'),
										dateDrank: $window.moment(drink.date).format('llll'),
										drinkSummary: drink.getSummary(),
										drinkNotes: drink.notes
									});
								});

							});

							self.report.groups.push({
								group: group,
								qtyDrank: $window.numeral(groupTotals.qtyDrank).format('0,0'),
								wines: formattedWines
							});

							// update grand total value
							grandTotals.qtyDrank += groupTotals.qtyDrank;
						});

						self.report.totals = [
							// 'Producer / Wine',
							'Total ' + keyNamePlural + ': ' + $window.numeral(grandTotals.groups).format('0,0') + '<br/>Total wines: ' + $window.numeral(grandTotals.wines).format('0,0'),
							// 'Size',
							null,
							// 'Date Drank',
							null,
							// 'Bottles Drank',
							$window.numeral(grandTotals.qtyDrank).format('0,0')
						];

						// hide loading
						self.report.loading = false;

						return true;
					}

					return false;

				}).catch(function(err){
				$log.debug('Error getting wines', err);
			});

		}

		function print(){
			return $window.print();
		}
	}

})();
